import React from 'react';
import { Select, Button, Grid, GridItem, Box, Text, Input, Icon, useToast } from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';

import xhr from 'xhr';
import useAuth from 'hooks/useAuth';

const INSTITUTIONS = [
  'INSTITUTO IBEROAMERICANO',
  'INSTITUTO TÉCNICO IBEROAMERICANO',
  'EDUDIGITAL SAS',
  'EDUCAMOS CON VALORES',
  'INECOL',
  'COLEGIO INTERNACIONAL LOS ANDES',
];

const RESTRICTED_USER_EMAIL = 'anapaolarondon1989@gmail.com';
const RESTRICTED_USER_INSTITUTION = 'EDUDIGITAL SAS';

function AddIndividualStudent({ setIsOpen }) {
  const [loadingButton, setLoadingButton] = React.useState(false);
  const { user } = useAuth();

  const institutions =
    user?.email?.toLowerCase() === RESTRICTED_USER_EMAIL
      ? [RESTRICTED_USER_INSTITUTION]
      : INSTITUTIONS;

  const toast = useToast();

  const updateData = async (values, action) => {
    try {
      setLoadingButton(true);
      const response = await xhr.post(`/student-graduateds`, {
        data: {
          ...values,
          valor: values.value,
        },
      });
      setIsOpen(false);
      toast({
        title: 'El estudiante se insertó correctamente!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      action.resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingButton(false);
    }
  };

  return (
    <>
      <Box backgroundColor="white" border="1px solid #e8e8e8" padding="20px" borderRadius="10px">
        <Text fontSize="25px" fontWeight="bold">
          Insertar estudiante
        </Text>

        <Formik
          enableReinitialize
          initialValues={{
            name: '',
            type_document: '',
            document: '',
            institution: '',
            program_finished: '',
            status: '',
            value: '',
            datePayment: '',
            semester: '',
          }}
          onSubmit={updateData}
        >
          <Form>
            <br />
            <Grid templateColumns="repeat(12, 1fr)" gap={5}>
              <GridItem colSpan={6}>
                <Box>Nombres</Box>
                <Field marginTop="20px" as={Input} name="name" />
              </GridItem>

              <GridItem colSpan={6}>
                <Box>Tipo Documento</Box>
                <Field marginTop="20px" as={Select} name="type_document">
                  <option value={''}>Seleccione</option>
                  <option value={'CC'}>Cédula de Ciudadanía</option>
                  <option value={'TI'}>Tarjeta de Identidad</option>
                  <option value={'CE'}>Cédula de Extranjería</option>
                  <option value={'PEP'}>PEP</option>
                  <option value={'PPT'}>PPT</option>
                </Field>
              </GridItem>
            </Grid>

            <Grid templateColumns="repeat(12, 1fr)" gap={5}>
              <GridItem colSpan={6}>
                <Box marginTop="5px" marginBottom="5px">
                  <Text fontWeight="500">Documento</Text>
                </Box>
                <Field marginTop="20px" type="number" as={Input} name="document" />
              </GridItem>

              <GridItem colSpan={6}>
                <Box marginTop="5px" marginBottom="5px">
                  <Text fontWeight="500">Institución</Text>
                </Box>
                <Field marginTop="20px" as={Select} name="institution">
                  <option value={''}>Seleccione</option>
                  {institutions.map((institution) => (
                    <option key={institution} value={institution}>
                      {institution}
                    </option>
                  ))}
                </Field>
              </GridItem>

              <GridItem colSpan={6}>
                <Box marginTop="5px" marginBottom="5px">
                  <Text fontWeight="500">Programa</Text>
                </Box>
                <Field marginTop="20px" as={Select} name="program_finished">
                  <option value={''}>Seleccione</option>
                  <option value={'Bachillerato Académico'}>Bachillerato Académico</option>
                  <option value={'Tecnico Laboral en Administracion, contable y financiero'}>
                    Tecnico Laboral en Administracion, contable y financiero
                  </option>
                  <option value={'Tecnico Laboral en Primera Infancia'}>Tecnico Laboral en Primera Infancia</option>
                  <option value={'Tecnico Laboral en Diseño Grafico'}>Tecnico Laboral en Diseño Grafico</option>
                  <option value={'Tecnico Laboral en Desarrollo Web'}>Tecnico Laboral en Desarrollo Web</option>
                  <option value={'Tecnico Laboral en Marketing Digital y ventas'}>
                    Tecnico Laboral en Marketing Digital y ventas
                  </option>
                  <option value={'Tecnico Laboral en Salud Ocupacional'}>Tecnico Laboral en Salud Ocupacional</option>
                  <option value={'Programa de Inglés A1, A2, B1 y B2'}>Programa de Inglés A1, A2, B1 y B2</option>
                  <option value={'Bachillerato Adultos'}>Bachillerato Adultos</option>
                  <option value={'Bachillerato Niños Tradicional Anual'}>Bachillerato Niños Tradicional Anual</option>
                  <option value={'Primaria Tradicional Anual'}>Primaria Tradicional Anual</option>
                  {/*  */}
                  <option value={'Conocimientos Académicos en Inglés A1'}>Conocimientos Académicos en Inglés A1</option>

                  <option value={'Conocimientos Académicos en Inglés A2'}>Conocimientos Académicos en Inglés A2</option>

                  <option value={'Conocimientos Académicos en Inglés B1'}>Conocimientos Académicos en Inglés B1</option>

                  <option value={'Conocimientos Académicos en Inglés B2'}>Conocimientos Académicos en Inglés B2</option>

                  <option value={'Tecnico Laboral en Sistemas informaticos y Base de datos'}>
                    Tecnico Laboral en Sistemas informaticos y Base de datos
                  </option>

                  <option value={'Tecnico Laboral en Seguridad Laboral y Ocupacional'}>
                    Tecnico Laboral en Seguridad Laboral y Ocupacional
                  </option>

                  <option value={'Tecnico LAboral en vigilancia y guarda de Seguridad'}>
                    Tecnico Laboral en vigilancia y guarda de Seguridad
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar en Gestión Documental y Administración de Archivo'}>
                    Tecnico Laboral en Auxiliar en Gestión Documental y Administración de Archivo
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar de Procesos y Servicios Logísticos'}>
                    Tecnico Laboral en Auxiliar de Procesos y Servicios Logísticos
                  </option>
                  <option value={'Tecnico Laboral por Competencias en Derechos Humanos'}>
                    Tecnico Laboral por Competencias en Derechos Humanos
                  </option>
                  <option value={'Tecnico Laboral en Teología Ministerial Bíblica'}>
                    Tecnico Laboral en Teología Ministerial Bíblica
                  </option>
                  <option value={'Tecnico laboral en Competencias Mantenimiento e Instalaciones Eléctricas '}>
                    Tecnico laboral en Competencias Mantenimiento e Instalaciones Eléctricas
                  </option>
                  <option value={'Tecnico Laboral en Vigilancia y Seguridad Privada'}>
                    Tecnico Laboral en Vigilancia y Seguridad Privada
                  </option>
                  <option value={'Tecnico Laboral en Asistente de Mercadeo y Publicidad '}>
                    Tecnico Laboral en Asistente de Mercadeo y Publicidad
                  </option>
                  <option value={'Tecnico Laboral en Asistente legal y Jurídico'}>
                    Tecnico Laboral en Asistente legal y Jurídico
                  </option>
                  <option value={'Tecnico Laboral por Competencias en Belleza'}>
                    Tecnico Laboral por Competencias en Belleza
                  </option>
                  <option value={'Tecnico Laboral en Competencias En Redes y Sistemas de Computación'}>
                    Tecnico Laboral en Competencias En Redes y Sistemas de Computación
                  </option>
                  <option value={'Tecnico Laboral en Agente de Tránsito y Seguridad Vial'}>
                    Tecnico Laboral en Agente de Tránsito y Seguridad Vial
                  </option>
                  <option value={'Tecnico Laboral Por Competencias en Auxiliar de Operaciones de Caja y Servicios en Almacenes de Cadena'}>
                    Tecnico Laboral Por Competencias en Auxiliar de Operaciones de Caja y Servicios en Almacenes de Cadena
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar de Operaciones y Servicios Portuarios'}>
                    Tecnico Laboral en Auxiliar de Operaciones y Servicios Portuarios
                  </option>
                  <option value={'Tecnico Laboral por Competencias en Auxiliar de Hotelería y Turismo'}>
                    Tecnico Laboral por Competencias en Auxiliar de Hotelería y Turismo
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar de Seguridad Integral y Prevención del Riesgo'}>
                    Tecnico Laboral en Auxiliar de Seguridad Integral y Prevención del Riesgo
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar de Servicios en Recreación y Deportes'}>
                    Tecnico Laboral en Auxiliar de Servicios en Recreación y Deportes
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar Administrativo en Salud'}>
                    Tecnico Laboral en Auxiliar Administrativo en Salud
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar en Servicios Farmacéuticos'}>
                    Tecnico Laboral en Auxiliar en Servicios Farmacéuticos
                  </option>
                  <option value={'Tecnica Laboral en Agente de Tránsito y Transporte'}>
                    Tecnica Laboral en Agente de Tránsito y Transporte
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar de Talento Humano'}>
                    Tecnico Laboral en Auxiliar de Talento Humano
                  </option>
                  <option value={'Tecnico Laboral en Competencias en Auxiliar de Oficinas'}>
                    Tecnico Laboral en Competencias en Auxiliar de Oficinas
                  </option>
                  <option value={'Tecnico Laboral en Competencias Pedagógicas'}>
                    Tecnico Laboral en Competencias Pedagógicas
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar en Saneamiento y Salud Ambiental'}>
                    Tecnico Laboral en Auxiliar en Saneamiento y Salud Ambiental
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar de Trabajo Social y Comunitario'}>
                    Tecnico Laboral en Auxiliar de Trabajo Social y Comunitario
                  </option>
                  <option value={'Tecnico Laboral en Auxiliar en Investigación Judicial y Criminalístico'}>
                    Tecnico Laboral en Auxiliar en Investigación Judicial y Criminalístico
                  </option>
                  <option value={'Tecnico Laboral en Entrenador y Preparador Físico'}>
                    Tecnico Laboral en Entrenador y Preparador Físico
                  </option>
                  <option value={'Tecnico Laboral en Atención al Adulto Mayor'}>
                    Tecnico Laboral en Atención al Adulto Mayor
                  </option>
                </Field>
              </GridItem>

              <GridItem colSpan={6}>
                <Box marginTop="5px" marginBottom="5px">
                  <Text fontWeight="500">Estado</Text>
                </Box>

                <Field marginTop="20px" as={Select} name="status">
                  <option value={''}>Seleccione</option>
                  <option value={'Aprobado'}>Aprobado</option>
                  <option value={'Retirado'}>Retirado</option>
                  <option value={'Pendiente de pago'}>Pendiente de pago</option>
                </Field>
              </GridItem>

              <GridItem colSpan={3}>
                <Box>Valor (opcional)</Box>
                <Field marginTop="20px" as={Input} name="value" />
              </GridItem>

              <GridItem colSpan={5}>
                <Box>Fecha limite de pago (opcional)</Box>
                <Field marginTop="20px" as={Input} type="date" name="datePayment" />
              </GridItem>

              <GridItem colSpan={4}>
                <Box>Semestre (opcional)</Box>
                <Field marginTop="20px" as={Select} name="semester">
                  <option value={''}>Seleccione</option>
                  <option value={'202401'}>2024-01</option>
                  <option value={'202402'}>2024-02</option>
                  <option value={'2024'}>2024</option>
                  <option value={'202501'}>2025-01</option>
                  <option value={'202502'}>2025-02</option>
                  <option value={'2025'}>2025</option>
                  <option value={'202601'}>2026-01</option>
                  <option value={'202602'}>2026-02</option>
                  <option value={'2026'}>2026</option>
                </Field>
              </GridItem>
            </Grid>

            <Button type="submit" palette="primary" marginY="10px" marginX="sm" width="140px" isLoading={loadingButton}>
              Insertar
            </Button>
          </Form>
        </Formik>
      </Box>
    </>
  );
}

export default AddIndividualStudent;
